import { useRef } from "react";


const AuditProperties = ({properties}) => {

    const closeRef = useRef();

    const parsedData = properties ? JSON.parse(properties) : {}
  return (
    <div>
        <h2>Action Details</h2>
      {parsedData && (
        <ul>
          {Object.entries(parsedData).map(([key, value]) => (
            // Exclude the property with the key "id"
            key !== 'id' && (
              <li key={key}>
                <strong>{key}:</strong> {value}
              </li>
            )
          ))}
        </ul>
      )}
        <div className='d-flex justify-content-end'>
            <div className='d-grid'>
            <button
                ref={closeRef}
                className='btn btn-sm mt-2 px-3 bg-secondary text-white'
                data-bs-dismiss='modal'
            >
                Close
            </button>
            </div>
        </div>
    </div>
  )
}

export default AuditProperties